<template>
  <header>
    <nav
      id="top-of-page"
      class="navbar navbar-expand-lg navbar-light btm-bar"
      :class="{ inverse: inverse }"
      :style="inverse ? {} : { backgroundColor: bgColor }"
    >
      <div class="container-fluid px-1 px-lg-5">
        <a class="navbar-brand" href="/">
          <!-- <img :src="`${$API_ASSETS}509d08fb-5e4c-461a-b041-aab23744c960.png`" class="img-fluid d-md-inline logo" alt="globe" /> -->
          <img :src="inverse ? `${$API_ASSETS}2a971657-e0a7-4dc3-8536-d2b682561f1a.png` : `${$API_ASSETS}41e4b0d7-2b51-456a-8504-55972fd1c8ee.png`" class="img-fluid logo" alt="Logo" />
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
          aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <ul class="navbar-nav ms-auto d-flex align-items-center">
            <li class="nav-item px-3">
              <router-link class="nav-link open-sans-500" to="/shows" @click="closeCollapse">Shows</router-link>
            </li>
            <!-- <li class="nav-item px-3">
              <router-link class="nav-link open-sans-500" to="/thecut" @click="closeCollapse">TheCut</router-link>
            </li> -->
            <li class="nav-item px-3">
              <router-link class="nav-link open-sans-500" to="/classes">Classes</router-link>
            </li>
            <li class="nav-item px-3">
              <router-link class="nav-link work-sans-500" to="/company">Company</router-link>
            </li>
            <li class="nav-item px-3">
              <router-link class="nav-link work-sans-500" to="/contact">Contact</router-link>
            </li>
            <li class="nav-item px-3">
              <router-link class="nav-link work-sans-500" to="/hireus">Hire</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: '#E35B4B', // Default background color if none is provided
    },
    inverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapsed: true,
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    closeCollapse() {
      this.isCollapsed = true;
    },
  },
  mounted() {
    setTimeout(() => {
    const el = document.getElementById('top-of-page');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, 100);
  },

  created() {
    // Set up a global navigation guard to update the admin level before navigation
    this.$router.beforeEach(() => {
      this.closeCollapse(); // Close the collapse element before navigating
    });
  },
};
</script>

<style scoped>
/* Add your styles here if needed */
/* Inverse Nav style */
.inverse {
  background-color: #231F20 !important;
}
.inverse .nav-link,
.inverse .navbar-brand,
.inverse .navbar-toggler,
.inverse .navbar-toggler-icon {
  color: white !important;
  fill: white !important;
}
.inverse .nav-link.router-link-exact-active {
  color: #fff !important;
}
/* Ensure logo images are not inverted */
.inverse .logo {
  filter: none;
}
.inverse .navbar-toggler {
  border-color: white;
}
.inverse .navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba%28255, 255, 255, 1%29' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
}
@media (max-width: 576px) {
  .nav-link {
    font-size: 1.5rem;
    display: block;
    width: 100vw;
    border-bottom: 2px solid currentColor;
    padding: 1rem 0 1rem 1rem;
    margin-left: -1rem;
    text-align: center;
    height: 100%;
    line-height: normal;
  }
}
</style>
